import { Validator } from "./_validator.js";

export class SelectionValidator extends Validator
{
  /**
   * コンストラクタ
   * @param { HTMLElement } element
   */
  constructor( element ) {
    super( element );
    this.items = element.querySelectorAll( '.c-checkbox, .c-radio, .c-chips input, td input' );
  }

  /**
   * バリデーション実行
   * @returns { void }
   */
  validateRun = () =>
  {
    if ( ! this.target.classList.contains( 'is--invalidValidation' ) ) {
      // エラー設定を初期化
      this.initError();

      this.attributeNames.forEach( attributeName => {
        if ( this.validationAttributes.includes( attributeName ) ) {
          const attributeValue = this.target.getAttribute( attributeName );

          switch ( attributeName ) {
            case 'data-required' :
              this.#required( attributeValue ); // 必須選択
              break;
          }
        }
      } );
    } else {
      this.errorCount = 0;
    }
    
    // バリデーション結果の反映
    this.resultReflection();
  }

  /**
   * 必須選択 （引数： 必要選択数 空の場合は「１」とみなします）
   * @param { Number } num
   * @returns { void }
   */
  #required = ( num ) =>
  {
    const min = num != '' ? Number( num ) : 1;
    let cnt   = 0;

    this.items.forEach( item => {
      if ( item.checked === true ) {
        cnt++;
      }
    } );

    if ( cnt < min ) {
      this.setErrorMessage( 'code014' );
      this.addErrorCount();
    }
  }
}
